const state = () => ({
  messages: null,
  unreadCount: 0,
  currentMessagePage: null,
  totalMessages: 0,
  messagePageIndex: 1,
  categories: [],
})
const getters = {
  messages: (state) => state.messages,
  unreadCount: (state) => state.unreadCount,
  currentMessagePage: (state) => state.currentMessagePage,
  totalMessages: (state) => state.totalMessages,
  messagePageIndex: (state) => state.messagePageIndex,
  categories: (state) => state.categories,
}
const mutations = {
  receiveMessages(state, messages) {
    state.messages = messages.messages
    state.unreadCount = messages.count
  },
  clearMessages(state) {
    state.messages = null
    state.unreadCount = 0
  },
  receiveMessagesPage(state, messagePage) {
    state.currentMessagePage = messagePage.messages
    state.totalMessages = messagePage.count
    state.messagePageIndex = messagePage.page
  },
  receiveCategories(state, categories) {
    state.categories = categories
  },
}
const actions = {
  getAllMessages({ commit, rootState }, { filter, offset, limit }) {
    return this.$axios
      .post('/akern-platform-backend/v1/customer/messages/list', {
        accessToken: rootState.user.token,
        filter: filter ?? null,
        offset: offset ?? 0,
        limit: limit ?? 10,
      })
      .then((response) => {
        commit('receiveMessagesPage', response.data)
      })
      .catch((error) => {
        console.error(error)
      })
  },
  markAllMessagesAsRead({ rootState, dispatch }) {
    return this.$axios
      .post('/akern-platform-backend/v1/customer/messages/mark-all-read', {
        accessToken: rootState.user.token,
      })
      .then(() => {
        dispatch('getEssentialMessages')
      })
      .catch((error) => {
        console.error(error)
      })
  },
  markMessageAsRead({ rootState, dispatch }, messageId) {
    return this.$axios
      .post('/akern-platform-backend/v1/customer/messages/mark-read', {
        accessToken: rootState.user.token,
        messageId,
      })
      .then(() => {
        dispatch('getEssentialMessages')
      })
      .catch((error) => {
        console.error(error)
      })
  },
  getEssentialMessages({ commit, rootState }) {
    return this.$axios
      .post('/akern-platform-backend/v1/customer/messages/essential-list', {
        accessToken: rootState.user.token,
      })
      .then((response) => {
        commit('receiveMessages', response.data)
      })
      .catch(() => {
        commit('clearMessages')
      })
  },
  deleteMessage({ rootState, dispatch }, messageId) {
    return this.$axios
      .post('/akern-platform-backend/v1/customer/messages/delete', {
        accessToken: rootState.user.token,
        messageId,
      })
      .then(() => {
        dispatch('getEssentialMessages')
      })
      .catch((error) => {
        console.error(error)
      })
  },
  getMessagesCategories({ commit, rootState }) {
    return this.$axios
      .post('/akern-platform-backend/v1/customer/messages/categories', {
        accessToken: rootState.user.token,
      })
      .then((response) => {
        commit('receiveCategories', response.data.categories)
      })
      .catch((error) => {
        console.error(error)
      })
  },
}
export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
